import { createRouter, createWebHistory, START_LOCATION } from 'vue-router';
import BooleanUtils from './utils/BooleanUtils';
import { useRum } from './v3/composables/useRum';
import { pageName } from './plugins/pageName';
import { syncReplayForPage } from './plugins/analytics.js';

const BASE_URL = process.env.BASE_URL;
console.log("v3=", BooleanUtils.toBoolean(window.localStorage["v3"] ?? true));

const buildV3Dmz = () => {
  return [
    {
      path: '/',
      name: 'home',
      component: () => import('./v3/pages/dmz/SignInView.vue')
    },
    {
      path: '/signin',
      name: 'signin',
      component: () => import('./v3/pages/dmz/SignInView.vue')
    },

    {
      path: '/my160',
      name: 'my160',
      component: () => import('./v3/pages/dmz/My160View.vue')
    },
    {
      path: '/isReadyChekRight4Me',
      name: 'isReadyChekRight4Me',
      component: () => import('./v3/pages/dmz/RightForMeView.vue')
    },

    {
      path: '/recovery',
      name: 'recovery',
      component: () => import('./v3/pages/dmz/PasswordRecoveryView.vue')
    },
    {
      path: '/register',
      name: 'register',
      component: () => import('./v3/pages/dmz/RegisterView.vue')
    },
    {
      path: '/verify/:registrationId',
      name: 'verify',
      component: () => import('./v3/pages/dmz/VerifyView.vue')
    },
    {
      path: '/signup',
      name: 'signup',
      component: () => import('./v3/pages/dmz/RegisterView.vue')
    },
    {
      path: '/sbo',
      name: 'sbo',
      component: () => import('./v3/pages/dmz/SboView.vue')
    },
  ];
}

const buildV3Operator = () => {
  return [
    //V3 Operator
    {
      path: '/portal/v3/operator/billing/paymentLink',
      name: 'portalV3OperatorPaymentLink',
      component: () => import('./v3/pages/operator/billing/PaymentLink.vue')
    },
    {
      path: '/portal/v3/operator/billing/paid',
      name: 'portalV3OperatorPaidInvoice',
      component: () => import('./v3/pages/operator/billing/PaidInvoice.vue')
    },
    {
      path: '/portal/v3/operator/:operatorId/whatsnew',
      name: 'portalV3OperatorWhatsNew',
      component: () => (import('./v3/pages/dmz/WhatsNewView.vue'))
    },
    {
      path: '/portal/v3/operator/:operatorId/dashboard',
      name: 'portalV3OperatorDashboard',
      component: () => import('./v3/pages/operator/dashboard/DashboardView.vue')
    },
    {
      path: '/portal/v3/operator/:operatorId/inspections',
      name: 'portalV3OperatorInspections',
      component: () => import('./v3/pages/operator/inspection/InspectionTableView.vue')
    },
    {
      path: '/portal/v3/operator/:operatorId/hours',
      name: 'portalV3OperatorHours',
      component: () => import('./v3/pages/operator/timesheet/TimesheetTableView.vue')
    },
    {
      path: '/portal/v3/operator/:operatorId/users',
      name: 'portalV3OperatorUsers',
      component: () => import('./v3/pages/operator/employee/EmployeeTableView.vue')
    },
    {
      path: '/portal/v3/operator/:operatorId/checklists',
      name: 'portalV3OperatorChecklists',
      component: () => import('./v3/pages/operator/checklist/ChecklistTableView.vue')
    },
    {
      path: '/portal/v3/operator/:operatorId/reports',
      name: 'portalV3OperatorReports',
      component: () => import('./v3/pages/operator/report/ReportTableView.vue')
    },
    {
      path: '/portal/v3/operator/:operatorId/invoices',
      name: 'portalV3OperatorInvoices',
      component: () => import('./v3/pages/operator/invoice/InvoiceTableView.vue')
    },
    {
      path: '/portal/v3/operator/:operatorId/billing/display',
      name: 'portalV3OperatorBilling',
      component: () => import('./v3/pages/operator/billing/BillingView.vue')
    },
    {
      path: '/portal/v3/operator/:operatorId/company/display',
      name: 'portalV3OperatorCompanyDisplay',
      component: () => import('./v3/pages/operator/company/CompanyView.vue')
    },
    {
      path: '/portal/v3/operator/:operatorId/compliance',
      name: 'portalV3OperatorCompliance',
      component: () => import('./v3/pages/operator/compliance/ComplianceTableView.vue')
    },
    {
      path: '/portal/v3/operator/:operatorId/map',
      name: 'portalV3OperatorMap',
      component: () => import('./v3/pages/operator/map/MapView.vue')
    },
    {
      path: '/portal/v3/operator/:operatorId/profile',
      name: 'portalV3OperatorProfile',
      component: () => import('./v3/pages/operator/profile/ProfileView.vue')
    },
    {
      path: '/portal/v3/operator/:operatorId/admin',
      name: 'portalV3OperatorAdmin',
      component: () => import('./v3/pages/admin/company/configuration/AdminConfigurationView.vue')
    },
    {
      path: '/portal/v3/operator/:operatorId/vehicles',
      name: 'portalV3OperatorVehicleList',
      component: () => import('./v3/pages/operator/vehicle/VehicleTableView.vue')
    },
    {
      path: '/portal/v3/operator/:operatorId/equipment',
      name: 'portalV3OperatorEquipmentList',
      component: () => import('./v3/pages/operator/equipment/EquipmentTableView.vue')
    },
    {
      path: '/portal/v3/operator/:operatorId/gps/devices',
      name: 'portalV3OperatorGpsDevices',
      component: () => import('./v3/pages/operator/gps/GpsDevicesTableView.vue')
    },
    {
      path: '/portal/operator/companys',
      name: 'portalOperatorCompanySelect',
      component: () => (window.localStorage.getItem("v3") == null || window.localStorage.getItem("v3") === 'true' ? import('./v3/pages/dmz/CompanySelectView.vue') : import('./portals/customer/operator/views/company/select/SelectView.vue'))
    },
  ];
}

const buildV3Admin = () => {
  return [
    {
      path: '/portal/v3/admin/checklists',
      name: 'portalV3AdminChecklist',
      component: () => import('./v3/pages/admin/checklist/AdminChecklistTableView.vue')
    },
    {
      path: '/portal/v3/admin/companies',
      name: 'portalV3AdminCompany',
      component: () => import('./v3/pages/admin/company/table/AdminCompanyTableView.vue')
    },
    {
      path: '/portal/v3/admin/dashboard',
      name: 'portalV3AdminDashboard',
      component: () => import('./v3/pages/admin/dashboard/AdminDashboardTableView.vue')
    },
    {
      path: '/portal/v3/admin/users',
      name: 'portalV3AdminEmployee',
      component: () => import('./v3/pages/admin/employee/AdminEmployeeTableView.vue')
    },
    {
      path: '/portal/v3/admin/equipment',
      name: 'portalV3AdminEquipment',
      component: () => import('./v3/pages/admin/equipment/AdminEquipmentTableView.vue')
    },
    {
      path: '/portal/v3/admin/gps/devices',
      name: 'portalV3AdminGpsDevice',
      component: () => import('./v3/pages/admin/gps/AdminGpsDeviceTableView.vue')
    },
    {
      path: '/portal/v3/admin/llm/prompts',
      name: 'portalV3AdminLlmPrompts',
      component: () => import('./v3/pages/admin/llm/AdminLlmPromptTableView.vue')
    },
    {
      path: '/portal/v3/admin/health',
      name: 'portalV3AdminHome',
      component: () => import('./v3/pages/admin/home/AdminHomeView.vue')
    },
    {
      path: '/portal/v3/admin/inspections',
      name: 'portalV3AdminInspection',
      component: () => import('./v3/pages/admin/inspection/AdminInspectionTableView.vue')
    },
    {
      path: '/portal/v3/admin/invoices',
      name: 'portalV3AdminInvoices',
      component: () => import('./v3/pages/admin/invoice/AdminInvoiceTableView.vue')
    },
    {
      path: '/portal/v3/admin/breakdown',
      name: 'portalV3AdminInvoiceBreakdown',
      component: () => import('./v3/pages/admin/invoice/AdminInvoiceBreakdownView.vue')
    },
    {
      path: '/portal/v3/admin/invoice/settings',
      name: 'portalV3AdminInvoiceSettings',
      component: () => import('./v3/pages/admin/invoice/settings/AdminInvoiceSettingsTableView.vue')
    },
    {
      path: '/portal/v3/admin/map',
      name: 'portalV3AdminMap',
      component: () => import('./v3/pages/admin/map/AdminMapView.vue')
    },
    {
      path: '/portal/v3/admin/registrations',
      name: 'portalV3AdminRegistration',
      component: () => import('./v3/pages/admin/registration/AdminRegistrationTableView.vue')
    },
    {
      path: '/portal/v3/admin/reports',
      name: 'portalV3AdminReport',
      component: () => import('./v3/pages/admin/report/AdminReportTableView.vue')
    },
    {
      path: '/portal/v3/admin/schedules',
      name: 'portalV3AdminSchedule',
      component: () => import('./v3/pages/admin/schedule/AdminScheduleTableView.vue')
    },
    {
      path: '/portal/v3/admin/gps/devices',
      name: 'portalV3AdminDevices',
      component: () => import('./v3/pages/admin/gps/AdminGpsDeviceTableView.vue')
    },
    {
      path: '/portal/v3/admin/stats',
      name: 'portalV3AdminStats',
      component: () => import('./v3/pages/admin/stats/AdminStatsTableView.vue')
    },
    {
      path: '/portal/v3/admin/hours',
      name: 'portalV3AdminHours',
      component: () => import('./v3/pages/admin/timesheet/AdminTimesheetTableView.vue')
    },
    {
      path: '/portal/v3/admin/vehicles',
      name: 'portalV3AdminVehicle',
      component: () => import('./v3/pages/admin/vehicle/AdminVehicleTableView.vue')
    },
    {
      path: '/portal/v3/admin/cards',
      name: 'portalV3AdminCard',
      component: () => import('./v3/pages/admin/card/AdminCardTableView.vue')
    },
    {
      path: '/portal/v3/admin/profile',
      name: 'portalV3AdminProfile',
      component: () => import('./v3/pages/admin/profile/AdminProfileTableView.vue')
    },
  ]
}

const buildV3AdminAcounts = () => {
  return [
    {
      path: '/portal/v3/admin/accounts/:operatorId/billing/display',
      name: 'portalV3AdminAccountsBilling',
      component: () => import('./v3/pages/accounts/billing/AccountsBillingView.vue')
    },
    {
      path: '/portal/v3/admin/accounts/:operatorId/configuration',
      name: 'portalV3AdminAccountsConfiguration',
      component: () => import('./v3/pages/accounts/configuration/AccountConfigurationView.vue')
    },
    {
      path: '/portal/v3/admin/accounts/:operatorId/dashboard',
      name: 'portalV3AdminAccountsAccountsDashboard',
      component: () => import('./v3/pages/accounts/dashboard/AccountsDashboardView.vue')
    },
    {
      path: '/portal/v3/admin/accounts/:operatorId/compliance',
      name: 'portalV3AdminAccountsCompliance',
      component: () => import('./v3/pages/accounts/compliance/AccountsComplianceView.vue')
    },
    {
      path: '/portal/v3/admin/accounts/:operatorId/vehicles',
      name: 'portalV3AdminAccountsDashboard',
      component: () => import('./v3/pages/accounts/vehicles/AccountsVehicleView.vue')
    },
    {
      path: '/portal/v3/admin/accounts/:operatorId/inspections',
      name: 'portalV3AdminAccountsInspections',
      component: () => import('./v3/pages/accounts/inspections/AccountsInspectionView.vue')
    },
    {
      path: '/portal/v3/admin/accounts/:operatorId/hours',
      name: 'portalV3AdminAccountsTimesheets',
      component: () => import('./v3/pages/accounts/timesheets/AccountsTimesheetView.vue')
    },
    {
      path: '/portal/v3/admin/accounts/:operatorId/users',
      name: 'portalV3AdminAccountsEmployees',
      component: () => import('./v3/pages/accounts/employees/AccountsEmployeeView.vue')
    },
    {
      path: '/portal/v3/admin/accounts/:operatorId/checklists',
      name: 'portalV3AdminAccountsChecklists',
      component: () => import('./v3/pages/accounts/checklists/AccountsChecklistView.vue')
    },
    {
      path: '/portal/v3/admin/accounts/:operatorId/reports',
      name: 'portalV3AdminAccountsReports',
      component: () => import('./v3/pages/accounts/reports/AccountsReportView.vue')
    },
    {
      path: '/portal/v3/admin/accounts/:operatorId/invoices',
      name: 'portalV3AdminAccountsInvoices',
      component: () => import('./v3/pages/accounts/invoices/AccountsInvoiceView.vue')
    },
    {
      path: '/portal/v3/admin/accounts/:operatorId/display',
      name: 'portalV3AdminAccountsCompany',
      component: () => import('./v3/pages/accounts/company/AccountsCompanyView.vue')
    },
    {
      path: '/portal/v3/admin/accounts/:operatorId/gps/devices',
      name: 'portalV3AdminAccountsGpsDevice',
      component: () => import('./v3/pages/accounts/gps/AccountsGpsDeviceView.vue')
    },
    {
      path: '/portal/v3/admin/accounts/:operatorId/map',
      name: 'portalV3AdminAccountsMap',
      component: () => import('./v3/pages/accounts/map/AccountsMapView.vue')
    },
    {
      path: '/portal/v3/admin/accounts/:operatorId/equipment',
      name: 'portalV3AdminAccountsEquipment',
      component: () => import('./v3/pages/accounts/equipment/AccountsEquipmentView.vue')
    },
  ];
}

const router = createRouter({
  history: createWebHistory(BASE_URL),
  routes: [

    {
      path: '/privacy',
      name: 'privacy',
      component: () => import('./views/privacy/Privacy.vue')
    },
    {
      path: '/signout',
      name: 'signout',
      component: () => import('./views/sign/out/SignOut.vue')
    },
    {
      path: '/portal/profile',
      name: 'portalprofile',
      component: () => import('./views/portal/profile/Profile.vue')
    },
    {
      path: '/portal/profile/password',
      name: 'portalchangepassword',
      component: () => import('./views/portal/profile/password/ChangePassword.vue')
    },
    {
      path: '/portal/home',
      name: 'portalhome',
      component: () => import('./views/portal/Home.vue')
    },
    {
      path: '/portal/settings',
      name: 'portalsettings',
      component: () => import('./views/portal/settings/Settings.vue')
    },
    {
      path: '/portal/operator/company/edit',
      name: 'portalcompanyedit',
      component: () => import('./views/portal/companys/Edit.vue')
    },

    {
      path: '/portal/operator/:operatorId/company/display',
      name: 'portalOperatorCompanyDisplay',
      component: () => import('./portals/customer/operator/views/company/display/DisplayView.vue')
    },
    {
      path: '/portal/operator/:operatorId/company/edit',
      name: 'portalOperatorCompanyEdit',
      component: () => import('./views/portal/companys/Edit.vue')
    },

    {
      path: '/portal/operator/vehicles',
      name: 'portalvehicles',
      component: () => import('./views/portal/vehicles/list/Vehicles.vue')
    },
    {
      path: '/portal/operator/:operatorId/vehicles',
      name: 'portalOperatorVehicleList',
      component: () => import('./portals/customer/operator/views/vehicle/list/ListView.vue')
    },
    {
      path: '/portal/operator/:operatorId/schedules',
      name: 'portalOperatorScheduleList',
      component: () => import('./portals/customer/operator/views/schedule/list/ListView.vue')
    },
    {
      path: '/portal/operator/:operatorId/vehicles/add',
      name: 'portalOperatorVehicleAdd',
      component: () => import('./portals/customer/operator/views/vehicle/add/VehicleAddView.vue')
    },
    {
      path: '/portal/operator/:operatorId/equipment',
      name: 'portalOperatorEquipmentList',
      component: () => import('./portals/customer/operator/views/equipment/list/ListView.vue')
    },

    {
      path: '/portal/operator/vehicles/:id/edit',
      name: 'portalvehicleedit',
      component: () => import('./views/portal/vehicles/edit/Edit.vue')
    },
    {
      path: '/portal/operator/vehicles/addv2',
      name: 'portalvehicleaddv2',
      component: () => import('./portals/customer/operator/views/vehicle/add/VehicleAddView.vue')
    },
    {
      path: '/portal/operator/vehicles/:id/editv2',
      name: 'portalvehicleeditv2',
      component: () => import('./portals/customer/operator/views/vehicle/edit/VehicleEditView.vue')
    },
    {
      path: '/portal/operator/vehicles/:id/details',
      name: 'portalvehicledetails',
      component: () => import('./views/portal/vehicles/details/Details.vue')
    },
    {
      path: '/portal/operator/vehicles/:id/inspections',
      name: 'portalVehicleInspections',
      component: () => import('./portals/customer/operator/views/vehicle/inspections/Inspections.vue')
    },
    {
      path: '/portal/operator/vehicles/add/:id',
      name: 'portalvehicleadd',
      component: () => import('./views/portal/vehicles/add/Add.vue')
    },

    {
      path: '/portal/operator/:operatorId/inspections',
      name: 'operatorInspectionsList',
      component: () => import('./portals/customer/operator/views/inspection/list/ListView.vue')
    },
    {
      path: '/portal/operator/inspections/:id/details',
      name: 'portalinspectiondetails',
      component: () => import('./portals/customer/operator/views/inspection/display/DisplayView.vue')
    },
    {
      path: '/portal/operator/inspections/:id/repair',
      name: 'portalinspectionrepairs',
      component: () => import('./views/portal/inspections/InspectionRepairs.vue')
    },
    {
      path: '/portal/operator/inspections/:id/remarks',
      name: 'portalInspectionRemarks',
      component: () => import('./views/portal/inspections/InspectionRemarks.vue')
    },

    {
      path: '/portal/operator/inspections/:id/email',
      name: 'portalInspectionEmail',
      component: () => import('./portals/customer/operator/views/inspection/Email.vue')
    },

    {
      path: '/portal/integrations/qbooks',
      name: 'integrationsQBooks',
      component: () => import('./portals/integrations/views/QBooks.vue')
    },

    {
      path: '/portal/operator/home',
      name: 'operatorHome',
      component: () => import('./portals/customer/operator/views/home/Home.vue')
    },
    {
      path: '/portal/operator/:operatorId/home',
      name: 'portalOperatorHome',
      component: () => import('./portals/customer/operator/views/home/Home.vue')
    },
    {
      path: '/portal/operator/whatsnew',
      name: 'operatorWhatsNew',
      component: () => import('./portals/customer/operator/views/home/WhatsNew.vue')
    },

    {
      path: '/portal/operator/:operatorId/whatsnew',
      name: 'portalOperatorWhatsNew',
      component: () => import('./portals/customer/operator/views/home/WhatsNew.vue')
    },

    {
      path: '/portal/operator/invoices',
      name: 'portalOperatorInvoices',
      component: () => import('./portals/customer/operator/views/invoice/list/Invoices.vue')
    },

    {
      path: '/portal/operator/:operatorId/invoices',
      name: 'portalOperatorInvoiceList',
      component: () => import('./portals/customer/operator/views/invoice/list/ListView.vue')
    },

    {
      path: '/portal/operator/billing/paid',
      name: 'operatorBillingPaid',
      component: () => import('./portals/customer/operator/views/billing/Paid.vue')
    },
    {
      path: '/portal/operator/billing/paymentLink',
      name: 'operatorBillingPaymentLink',
      component: () => import('./portals/customer/operator/views/billing/PaymentLink.vue')
    },
    {
      path: '/portal/operator/billing/details',
      name: 'operatorBillingDetails',
      component: () => import('./portals/customer/operator/views/billing/Details.vue')
    },
    {
      path: '/portal/operator/:operatorId/billing/display',
      name: 'operatorBillingDisplay',
      component: () => import('./portals/customer/operator/views/billing/display/DisplayView.vue')
    },
    {
      path: '/portal/operator/:operatorId/billing/list',
      name: 'operatorBillingList',
      component: () => import('./portals/customer/operator/views/billing/list/ListView.vue')
    },
    {
      path: '/portal/operator/payment/edit',
      name: 'operatorPaymentEdit',
      component: () => import('./portals/customer/operator/views/payment/UpdateCard.vue')
    },

    {
      path: '/portal/operator/compliance',
      name: 'operatorCompliance',
      component: () => import('./portals/customer/operator/views/compliance/Compliance.vue')
    },

    {
      path: '/portal/operator/:operatorId/compliance',
      name: 'operatorComplianceList',
      component: () => import('./portals/customer/operator/views/compliance/list/ListView.vue')
    },

    {
      path: '/portal/operator/:operatorId/hours',
      name: 'operatorTimesheetList',
      component: () => import('./portals/customer/operator/views/timesheet/list/ListView.vue')
    },
    {
      path: '/portal/operator/hours/:id/details',
      name: 'operatorTimesheetDetails',
      component: () => import('./portals/customer/operator/views/timesheet/details/TimesheetDetails.vue')
    },

    {
      path: '/portal/operator/checkins',
      name: 'operatorCheckIns',
      component: () => import('./portals/customer/operator/views/checkin/list/CheckIns.vue')
    },
    {
      path: '/portal/operator/checkins/:id/details',
      name: 'operatorCheckInDetails',
      component: () => import('./portals/customer/operator/views/checkin/details/CheckInDetails.vue')
    },

    {
      path: '/portal/operator/schedules',
      name: 'portalOperatorSchedules',
      component: () => import('./portals/customer/operator/views/schedule/List.vue')
    },

    {
      path: '/portal/operator/checklists',
      name: 'portalOperatorCheckListLists',
      component: () => import('./portals/customer/operator/views/checklist/ListView.vue')
    },
    {
      path: '/portal/operator/:operatorId/checklists',
      name: 'portalOperatorChecklists',
      component: () => import('./portals/customer/operator/views/checklist/list/ListView.vue')
    },

    {
      path: '/portal/operator/checklists/add',
      name: 'portalOperatorCheckListAdd',
      component: () => import('./portals/customer/operator/views/checklist/AddView.vue')
    },
    {
      path: '/portal/operator/checklists/:id/details',
      name: 'portalOperatorCheckListDetails',
      component: () => import('./portals/customer/operator/views/checklist/DetailsView.vue')
    },
    {
      path: '/portal/operator/checklists/:id/edit',
      name: 'portalOperatorCheckListEdit',
      component: () => import('./portals/customer/operator/views/checklist/EditView.vue')
    },

    {
      path: '/portal/operator/schedules/:id/details',
      name: 'portalOperatorSchedulesDetails',
      component: () => import('./portals/customer/operator/views/schedule/Details.vue')
    },
    {
      path: '/portal/operator/schedules/:id/edit',
      name: 'portalOperatorSchedulesEdit',
      component: () => import('./portals/customer/operator/views/schedule/Edit.vue')
    },

    // {
    //   path: '/portal/operator/users',
    //   name: 'portalOperatorUsers',
    //   component: () => import('./portals/customer/operator/views/employee/List.vue')
    // },

    {
      path: '/portal/operator/:operatorId/map',
      name: 'portalOperatorMapList',
      component: () => import('./portals/customer/operator/views/map/list/MapListView.vue')
    },

    {
      path: '/portal/operator/:operatorId/users',
      name: 'portalOperatorUsers',
      component: () => import('./portals/customer/operator/views/employee/list/ListView.vue')
    },
    {
      path: '/portal/operator/:operatorId/users/:userId/profile',
      name: 'portalOperatorUserProfile',
      component: () => import('./portals/customer/operator/views/employee/profile/ProfileView.vue')
    },
    {
      path: '/portal/operator/:operatorId/users/:id/edit',
      name: 'portalOperatorUsersEdit',
      component: () => import('./portals/customer/operator/views/employee/Edit.vue')
    },
    {
      path: '/portal/operator/users/license/:id',
      name: 'portalOperatorUsersLicense',
      component: () => import('./portals/customer/operator/views/employee/License.vue')
    },
    {
      path: '/portal/operator/users/file/:id',
      name: 'portalOperatorUsersFile',
      component: () => import('./portals/customer/operator/views/employee/File.vue')
    },
    {
      path: '/portal/operator/users/:id/inspections',
      name: 'portalOperatorUsersInspections',
      component: () => import('./portals/customer/operator/views/employee/Inspections.vue')
    },
    {
      path: '/portal/operator/users/:id/hours',
      name: 'portalOperatorUsersHours',
      component: () => import('./portals/customer/operator/views/employee/Hours.vue')
    },
    {
      path: '/portal/operator/:operatorId/users/:id/details',
      name: 'portalOperatorUsersDetails',
      component: () => import('./portals/customer/operator/views/employee/Details.vue')
    },
    {
      path: '/portal/operator/:operatorId/users/add',
      name: 'portalOperatorUsersAdd',
      component: () => import('./portals/customer/operator/views/employee/Add.vue')
    },
    {
      path: '/portal/operator/:operatorId/users/invite',
      name: 'portalOperatorUsersInvite',
      component: () => import('./portals/customer/operator/views/employee/Invite.vue')
    },
    {
      path: '/portal/operator/:operatorId/reports',
      name: 'portalOperatorReports',
      component: () => import('./portals/customer/operator/views/report/list/ListView.vue')
    },
    {
      path: '/portal/load/company',
      name: 'portalSharedLoadCompany',
      component: () => import('./portals/customer/shared/load/company/LoadCompanyView.vue')
    },

    //
    //ADMIN SECTION V1
    //
    {
      path: '/portal/admin/home',
      name: 'portaladminhome',
      component: () => import('./portals/admin/Home.vue')
    },
    {
      path: '/portal/admin/stats',
      name: 'portaladminstats',
      component: () => import('./portals/admin/stats/Stats.vue')
    },
    {
      path: '/portal/admin/lists',
      name: 'portaladminlists',
      component: () => import('./portals/admin/lists/Lists.vue')
    },
    {
      path: '/portal/admin/invoices',
      name: 'portalAdminInvoices',
      component: () => import('./portals/admin/invoices/Invoices.vue')
    },
    {
      path: '/portal/admin/checkins',
      name: 'portalAdminCheckIns',
      component: () => import('./portals/admin/checkins/CheckIns.vue')
    },
    {
      path: '/portal/admin/inspections',
      name: 'portalAdminInspections',
      component: () => import('./portals/admin/inspections/Inspections.vue')
    },
    {
      path: '/portal/admin/employees',
      name: 'portalAdminEmployees',
      component: () => import('./portals/admin/employees/Employees.vue')
    },
    {
      path: '/portal/admin/vehicles',
      name: 'portalAdminVehicles',
      component: () => import('./portals/admin/vehicles/Vehicles.vue')
    },
    {
      path: '/portal/admin/hours',
      name: 'portalAdminHours',
      component: () => import('./portals/admin/hours/Hours.vue')
    },
    {
      path: '/portal/admin/schedules',
      name: 'portalAdminSchedules',
      component: () => import('./portals/admin/schedules/Schedules.vue')
    },

    {
      path: '/portal/admin/new',
      name: 'adminCompanyNew',
      component: () => import('./portals/admin/register/New.vue')
    },
    {
      path: '/portal/admin/register',
      name: 'portaladminregister',
      component: () => import('./portals/admin/register/Register.vue')
    },

    {
      path: '/portal/admin/companys',
      name: 'portalAdminCompanys',
      component: () => import('./portals/admin/companys/Companys.vue')
    },
    {
      path: '/portal/admin/companys/:id/details',
      name: 'portalAdminCompanyDetails',
      component: () => import('./portals/admin/details/DetailsRow.vue')
    },
    {
      path: '/portal/admin/companys/:id/billing',
      name: 'portalAdminCompanyBilling',
      component: () => import('./portals/admin/details/BillingRow.vue')
    },
    {
      path: '/portal/admin/companys/:id/Compliance',
      name: 'portalAdminCompanyCompliance',
      component: () => import('./portals/admin/details/ComplianceRow.vue')
    },
    {
      path: '/portal/admin/companys/:id/home',
      name: 'portalAdminCompanyStats',
      component: () => import('./portals/admin/details/StatsRow.vue')
    },
    {
      path: '/portal/admin/companys/:id/employees',
      name: 'portalAdminCompanyEmployees',
      component: () => import('./portals/admin/details/EmployeesRow.vue')
    },
    {
      path: '/portal/admin/companys/:id/vehicles',
      name: 'portalAdminCompanyVehicles',
      component: () => import('./portals/admin/details/VehiclesRow.vue')
    },
    {
      path: '/portal/admin/companys/:id/inspections',
      name: 'portalAdminCompanyInspections',
      component: () => import('./portals/admin/details/InspectionsRow.vue')
    },
    {
      path: '/portal/admin/companys/:id/hours',
      name: 'portalAdminCompanyHours',
      component: () => import('./portals/admin/details/HoursRow.vue')
    },
    {
      path: '/portal/admin/companys/:id/checkins',
      name: 'portalAdminCompanyCheckIns',
      component: () => import('./portals/admin/details/CheckInsRow.vue')
    },
    {
      path: '/portal/admin/companys/:id/invoices',
      name: 'portalAdminCompanyInvoices',
      component: () => import('./portals/admin/details/InvoicesRow.vue')
    },
    {
      path: '/portal/admin/companys/:id/invoiceSettings',
      name: 'portalAdminCompanyInvoiceSettings',
      component: () => import('./portals/admin/details/BillingRow.vue')
    },
    {
      path: '/portal/admin/companys/:id/schedules',
      name: 'portalAdminCompanySchedules',
      component: () => import('./portals/admin/details/SchedulesRow.vue')
    },
    {
      path: '/portal/admin/companys/:id/checklists',
      name: 'portalAdminCompanyChecklists',
      component: () => import('./portals/admin/details/ChecklistsRow.vue')
    },

    // ADMIN V2
    {
      path: '/portal/admin/blank',
      name: 'portalAdminBlank',
      component: () => import('./portals/admin/views/blank/BlankView.vue')
    },
    {
      path: '/portal/admin/whatsnew',
      name: 'portalAdminWhatsNew',
      component: () => import('./portals/admin/views/whatsnew/list/ListView.vue')
    },
    {
      path: '/portal/admin/equipment/list',
      name: 'portalAdminEquipment',
      component: () => import('./portals/admin/views/equipment/list/ListView.vue')
    },
    {
      path: '/portal/admin/card/list',
      name: 'portalAdminCards',
      component: () => import('./portals/admin/views/cards/list/ListView.vue')
    },
    {
      path: '/portal/admin/company/list',
      name: 'portalAdminCompanyList',
      component: () => import('./portals/admin/views/company/list/ListView.vue')
    },
    {
      path: '/portal/admin/registration/list',
      name: 'portalAdminRegistrationList',
      component: () => import('./portals/admin/views/registration/list/ListView.vue')
    },
    {
      path: '/portal/admin/dashboard',
      name: 'portalAdminDashboardList',
      component: () => import('./portals/admin/views/DashboardView.vue')
    },
    {
      path: '/portal/admin/vehicle/list',
      name: 'portalAdminVehicleList',
      component: () => import('./portals/admin/views/vehicle/list/ListView.vue')
    },
    {
      path: '/portal/admin/user/list',
      name: 'portalAdminUserList',
      component: () => import('./portals/admin/views/user/list/ListView.vue')
    },
    {
      path: '/portal/admin/inspection/list',
      name: 'portalAdminInspectionList',
      component: () => import('./portals/admin/views/inspection/list/ListView.vue')
    },
    {
      path: '/portal/admin/map/list',
      name: 'portalAdminMapList',
      component: () => import('./portals/admin/views/map/list/AdminMapListView.vue')
    },
    {
      path: '/portal/admin/hour/list',
      name: 'portalAdminHoursList',
      component: () => import('./portals/admin/views/timesheet/list/ListView.vue')
    },
    {
      path: '/portal/admin/checklist/list',
      name: 'portalAdminChecklistList',
      component: () => import('./portals/admin/views/checklist/list/ListView.vue')
    },
    {
      path: '/portal/admin/schedule/list',
      name: 'portalAdminScheduleList',
      component: () => import('./portals/admin/views/schedule/list/ListView.vue')
    },
    {
      path: '/portal/admin/invoice/list',
      name: 'portalAdminInvoiceList',
      component: () => import('./portals/admin/views/invoice/list/ListView.vue')
    },
    {
      path: '/portal/admin/report/list',
      name: 'portalAdminReportList',
      component: () => import('./portals/admin/views/report/list/ListView.vue')
    },
    {
      path: '/portal/operator/:operatorId/admin',
      name: 'portalOperatorAdmin',
      component: () => import('./portals/customer/operator/views/admin/list/ListView.vue')
    },

    ...buildV3Dmz(),

    ...buildV3Operator(),

    // V3 Admin
    ...buildV3Admin(),

    //V3 Accounts
    ...buildV3AdminAcounts(),
  ]
})

/**
 * Every page opened, named, once.
 *
 * PostHog's own pageview capture is switched off in plugins/analytics.js,
 * because it would record a scrubbed URL rather than the name of the page.
 * Before this hook existed only four pages called trackPageView() themselves,
 * so PostHog saw a pageview for four routes out of fifty-six while page-leaves,
 * web vitals and dead clicks arrived from all of them - every rate built on a
 * pageview read far too low.
 *
 * Only a change of path counts. The dashboard pushes a query-only navigation
 * every time a card is clicked or the page refreshes, and those are not new
 * pages; counting them would inflate the very number this hook exists to
 * correct. The first navigation of the session always counts, whatever it is.
 */
const { trackPageView } = useRum();

router.afterEach((to, from) => {
  if (from !== START_LOCATION && to.path === from.path) {
    return;
  }
  const page = pageName(to);
  trackPageView(page);
  // Session replay follows the page, and only ever runs on the two public
  // marketing pages - see RECORDED_PAGES in plugins/analytics.js. Deciding it
  // here rather than in a page means a screen cannot opt itself in, and
  // leaving one always turns recording off.
  syncReplayForPage(page);
});

export default router;